<template>
  <div
    id="invoice-create"
    class="group-setup"
    v-if="hasPermission('invoice.create')"
  >
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-form v-if="!loading">
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-card class="pa-5" flat>
            <HeaderDividerBlock
              headerText="Create Invoice"
            ></HeaderDividerBlock>
            <v-row>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Project Code</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <v-progress-linear
                    indeterminate
                    color="success"
                    v-if="loadingData"
                  ></v-progress-linear>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <v-autocomplete
                    v-model="form.job_no"
                    :items="this.jobs"
                    item-text="project_code"
                    item-value="uuid"
                    outlined
                    dense
                    required
                    clearable
                    :hint="this.form.job_no ? form.project_customer : ''"
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
              </v-col>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Issue Date</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <DatePicker
                    :label="''"
                    v-model="form.invoice_date"
                    :selectValue="form.invoice_date"
                    @changeInput="form.invoice_date = $event"
                  >
                  </DatePicker>
                </v-col>
              </v-col>
              <v-col cols="6" md="4" sm="6">
                <v-col class="pa-0 ma-0">
                  <p class="text-title">Due Date</p>
                </v-col>
                <v-col class="pa-0 ma-0">
                  <DatePicker
                    :label="''"
                    v-model="dueDate"
                    :selectValue="dueDate"
                    @changeInput="dueDate = $event"
                  >
                  </DatePicker>
                </v-col>
              </v-col>
            </v-row>
            <v-col cols="12" md="12" sm="12">
              <InvoiceItems @invoice-items="handleInvoiceItems"></InvoiceItems>
            </v-col>
            <v-row cols="12" md="12" sm="12">
              <v-col cols="12" md="8" sm="12">
                <v-row class="d-none">
                  <v-col cols="auto">
                    <v-switch
                      v-model="xeroActive"
                      label="Create Invoice on Xero"
                      color="success"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-col>
                  <v-textarea
                    auto-grow
                    rows="4"
                    row-height="30"
                    outlined
                    v-model="form.invoice_note"
                    class="d-none"
                  ></v-textarea>
                </v-col>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-row class="d-none">
                  <v-col cols="auto">
                    <v-switch
                      v-model="discountActive"
                      label="Discount (%)"
                      color="success"
                    ></v-switch>
                  </v-col>
                  <v-col v-if="discountActive" cols="auto">
                    <v-text-field
                      outlined
                      type="number"
                      dense
                      v-model="discountValue"
                      placeholder="Enter discount"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-col>
                  <v-col class="ma-0 pa-0">
                    <p class="text-h5 font-weight-bold">Total</p>
                  </v-col>
                  <v-col class="px-7 pa-10 total-section">
                    <v-row class="justify-space-between">
                      <p
                        class="text-subtitle-1 font-weight-bold text-uppercase"
                      >
                        Sub Total
                      </p>
                      <p>{{ this.itemsSubTotal }}</p>
                    </v-row>
                    <v-row class="justify-space-between">
                      <p
                        class="text-subtitle-1 font-weight-bold text-uppercase"
                      >
                        Total {{ taxType }}
                      </p>
                      <p>{{ this.itemsTotalGST }}</p>
                    </v-row>
                    <v-row class="justify-space-between">
                      <p
                        class="text-subtitle-1 font-weight-bold text-uppercase"
                      >
                        Total {{ currencyCode }}
                      </p>
                      <p class="text-subtitle-1 font-weight-bold">
                        {{ calculateTotal() }}
                      </p>
                    </v-row>
                    <v-row class="justify-space-between d-none">
                      <p
                        class="text-subtitle-1 font-weight-bold text-uppercase"
                      >
                        Discount (%)
                      </p>
                      <p>{{ this.discountValue || "-" }}</p>
                    </v-row>
                  </v-col>
                </v-col>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card-actions class="mt-10">
                  <v-row>
                    <v-col cols="12" md="10" xs="6"></v-col>
                    <v-col cols="12" md="2" xs="6">
                      <v-btn
                        large
                        color="#00B3FF"
                        dark
                        depressed
                        block
                        @click="submit()"
                        >Create Invoice</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { InvoiceService } from "@/services/invoice-service.js";
import { ProjectService } from "@/services/project-service.js";
import { checkError } from "@/config/errors.js";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import InvoiceItems from "@/components/invoices/InvoiceItems.vue";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");

export default {
  name: "CreateProject",

  components: {
    Alert,
    Snackbars,
    DatePicker,
    HeaderDividerBlock,
    InvoiceItems,
  },
  props: ["uuid"],
  data: () => ({
    loading: false,
    loadingData: false,
    errors: null,
    snackbar: false,
    project_name: "",
    customer_name: "",
    succesMsg: "",
    form: {
      job_no: null,
      project_customer: "",
      invoice_date: new Date().toISOString().substr(0, 10),
    },
    jobs: [],
    role: localStorage.getItem("role") || null,
    customers: [],
    discountActive: false,
    xeroActive: true,
    discountValue: 0,
    itemsTotal: 0,
    itemsSubTotal: 0,
    itemsTotalGST: 0,
    items: [],
    dueDate: new Date().toISOString().substr(0, 10),
    page: 1,
    search: "",
    searchStatus: "",
  }),

  mounted() {
    this.getProjectList();
    this.getProjectUuid();
  },
  watch: {
    discountValue: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.calculateTotal();
      }
    },

    "form.job_no": function(newValue, oldValue) {
      if (this.form.job_no !== null) {
        if (newValue !== oldValue) {
          this.getProjectInfo();
        }
      }
    },
    items: {
      handler: function(newItems, oldItems) {
        if (JSON.stringify(newItems) !== JSON.stringify(oldItems)) {
          this.calculateTotal();
          this.handleInvoiceItems(newItems);
        }
      },
      deep: true,
    },
    search() {
      this.getProjectList();
      this.page = 1;
    },
    page() {
      this.getProjectList();
    },
  },
  computed: {
    ...mapGetters({
      member: "profile",
      hasPermission: "hasPermission",
    }),
    ...mapSettingsGetters({
      currencyCode: "currencyCode",
      taxType: 'taxType',
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      let fd = new FormData();

      fd.append("project_code", this.form.job_no || "");
      fd.append("invoice_date", this.form.invoice_date || "");
      fd.append("due_date", this.dueDate || "");
      fd.append("total_discount", this.discountValue);
      fd.append("total_gst", this.itemsTotalGST || "");
      fd.append("sub_total", this.itemsSubTotal || "");
      fd.append("total_amount", this.itemsTotal || "");
      fd.append("xero_invoice", this.xeroActive || false);
      fd.append("invoice_items", JSON.stringify(this.items) || []);
      fd.append("status", "DRAFT");

      InvoiceService.createInvoice(fd)
        .then((response) => {
          this.loading = false;
          if (response.status == 200) {
            this.succesMsg = response.data.message;
            this.snackbar = true;
            this.reset();
            this.$router.push(`/invoices`);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },

    getProjectUuid() {
      this.form.job_no = this.$route.params.uuid;
    },

    clossSnackbar() {
      this.snackbar = false;
    },
    toggleDiscount() {
      this.discountActive = !this.discountActive;
    },
    toggleXero() {
      this.xeroActive = !this.xeroActive;
    },
    handleInvoiceItems(items) {
      this.calculateTotal();
      this.items = items;
      this.itemsSubTotal = items.reduce(
        (total, item) => total + (Number(item.amount) || 0),
        0
      );
      this.itemsTotalGST = items.reduce(
        (totalGST, item) => totalGST + (Number(item.totalGST) || 0),
        0
      );
    },
    calculateTotal() {
      let total = this.itemsSubTotal + this.itemsTotalGST;
      if (this.discountActive && this.discountValue) {
        const discountPercentage = parseFloat(this.discountValue) || 0;
        const discountAmount = (total * discountPercentage) / 100;
        total -= discountAmount;
        this.itemsTotal = total.toFixed(2);
      }
      this.itemsTotal = total.toFixed(2);
      return total;
    },

    getProjectList() {
      this.loadingData = true;
      ProjectService.getProjectList(this.search,this.searchStatus, this.page)
        .then((response) => {
          this.loadingData = false;
          if (response.data.data) {
            this.jobs = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalProject = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.projects = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getProjectInfo() {
      this.loadingData = true;
      ProjectService.getProjectCustomerInfo(this.form.job_no)
        .then((response) => {
          this.loadingData = false;
          if (response.data.data) {
            const projectData = response.data.data;
            this.project_name = projectData.project_name;
            this.customer_name = projectData.customer.full_name;
            this.form.project_customer =
              this.project_name + " - " + this.customer_name;
            console.log(this.form.project_customer);
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    handleDueDate(date) {
      this.dueDate = date;
    },
    reset() {
      this.discountActive = false;
      this.xeroActive = false;
      this.discountValue = 0;
      this.itemsTotal = 0;
      this.itemsSubTotal = 0;
      this.itemsTotalGST = 0;
      this.items = [];
      this.form = [];
    },
  },
};
</script>
